<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container sf-datatable-container__appr">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th rowspan="3" class="col-1">결재</th>
							<th class="col-1">작성</th>
							<th class="col-1">승인</th>
							<th class="col-1">결재</th>
						</tr>
						<tr>
							<td class="col-1"><el-input v-model="input1" /></td>
							<td class="col-1"><el-input v-model="input1" /></td>
							<td class="col-1"><el-input v-model="input1" /></td>
						</tr>
						<tr>
							<td class="col-1"><el-input v-model="input1" /></td>
							<td class="col-1"><el-input v-model="input1" /></td>
							<td class="col-1"><el-input v-model="input1" /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	}
};
</script>

<style lang="scss" scoped>
.sf-datatable-container__appr {
	width: 100%;
	display: flex;
	align-items: flex-end;
	& > .sf-table {
		width: 30%;
	}
}
</style>
